import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

import Layout from '../../layouts'
import LargeHero from "../../components/elements/largeHero"
import { SizedText, Canon, Body } from "../../components/elements/typography"


import Grid from '../../components/elements/grid'
import Icon from '../../components/elements/icon'
import IconNavMenu from "../../components/molocules/menus/iconNavMenu"
import SEO from '../../components/elements/seo'

import checkingAccountIcon from '../../theme/icons/checking.svg'
import savingsAccountIcon from '../../theme/icons/savings.svg'
import creditCardsIcon from '../../theme/icons/credit-card.svg'
import loanIcon from '../../theme/icons/loan.svg'
import mortgageIcon from '../../theme/icons/mortgage.svg'
import digitalBankingIcon from '../../theme/icons/digital-banking.svg'
import rightArrowIcon from "../../theme/icons/right-arrow.svg"


import linkIcon from "../../theme/icons/link.svg"
import CustomerServiceSection from '../../components/sections/customerServiceSection'
import ReviewSection from '../../components/sections/reviewSection'
import PhExternalLink from '../../components/elements/externalLink'



const PersonalIndexPage = () => {
  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>

      <SEO
        title="Personal Banking Made Simple - The Claxton Bank"
        description="The Claxton Bank is committed to making banking simple and acccessable to all. Let us help you with your personal banking needs, credit cards, loans, mortgages, and more."
        location="/personal"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />

      { /* --- HERO SECTION ----*/ }
      <LargeHero.Container
        background={{ 
          //https://www.svgbackgrounds.com/
          backgroundColor: `#00D2FF`,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(240)'%3E%3Cstop offset='0' stop-color='%2395DAF7'/%3E%3Cstop offset='1' stop-color='%234ECBFF'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E")`,
          backgroundAttachment: `fixed`,
          backgroundSize: `cover`,
        }}
        styles={{
          paddingBottom: `0`,
          '@media (min-width: 680px)': {
            paddingBottom: `4rem`,
            '.heroContent': { width: `calc(60% - 1rem)`},
            '.heroImage': { width: `calc(40% - 1rem)`},
          },
          '@media (min-width: 1080px)': {
            '.heroContent': { width: `calc(55% - 2.5rem) !important`},
            '.heroImage': { width: `calc(45% - 2.5rem) !important`},
          }
      }}>
        <LargeHero.Content>
          <LargeHero.Eyebrow text="Personal Banking" />
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`, 'span': {display: `block`, lineHeight: `1.25`, padding: `0.25rem 0`, hyphens: `auto`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">All New Online Account Opening</SizedText>
          </h1>
          <p css={{fontSize: `1.125rem`, maxWidth: `850px`, padding: `1.25rem 0`, lineHeight: `1.75`, textAlign:`justify`, hyphens: `auto` }}>
            Can't make it to the bank?  No problem, open an account online with just a few simple clicks. Introducing 
            TCB NuFund, a new platform that lets you apply for and fund your account from any device, wherever you are.  
            Opening a new account has never been so easy. Apply for a new account today.
          </p>
          <div css={{margin: `2rem 0`, fontSize: `1.125rem`}}>
            <a href="https://theclaxtonbank.csinufund.com/home/newUser" css={{
              padding: `0.75rem 2rem`,
              backgroundColor: `#2ecc71`,
              //background: `linear-gradient(55deg, rgba(26,188,156,1) 0%, rgba(22,160,133,1) 100%)`,
              marginRight: `2rem`,
              borderRadius: `0.5rem`,
              color: `#fff !important`,
              textDecoration: `none`
            }}>
              <span>Apply Now</span>
              <span css={{paddingLeft: `0.75rem`}}><Icon icon={rightArrowIcon} overrides={{verticalAlign: `-0.25rem !important`}}/></span>
            </a>
            <Link to="/resources/product-tips/online-account-opening">
              <span>Learn More</span>
              <span css={{paddingLeft: `0.75rem`}}><Icon icon={linkIcon} overrides={{verticalAlign: `-0.1rem !important`}}/></span>
            </Link>
          </div>
        </LargeHero.Content>
        <LargeHero.Image>
        <StaticImage 
          css={{
            display: `block !important`,  
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../images/products/nufund/nufund-ipad_mobile.png" 
          alt="TCB NuFund Online Account Opening" 
        />
        <StaticImage 
          css={{
            display: `none !important`,  
            '@media (min-width: 736px)': { display: 'block !important' }, 
            '@media (min-width: 1024px)': { display: 'none !important' } 
          }} 
          src="../../images/products/nufund/nufund-ipad_tablet.png" 
          alt="TCB NuFund Online Account Opening" 
        />
        <StaticImage 
          css={{
            display: `none !important`,  
            '@media (min-width: 1024px)': { display: 'block !important' } 
          }} 
          src="../../images/products/nufund/nufund-ipad_desktop.png" 
          alt="TCB NuFund Online Account Opening" 
        />
        </LargeHero.Image>
      </LargeHero.Container>

      { /* --- Products SECTION ----*/ }
      <Grid.FullWidthSection styles={{ }}>
        <Grid.Block start="2" span="12" css={{textAlign: `left`, margin: `4rem 0 0 1rem`}}>
          <Canon>Explore All Our Products and Sevices</Canon>
        </Grid.Block>
        <Grid.Block start="2" span="12">
          <IconNavMenu menuItems={[
            {icon: checkingAccountIcon, shortText: `Checking`, longText: `Open a Checking Account`, url: `/personal/checking/`},
            {icon: savingsAccountIcon, shortText: `Savings`, longText: `Discover Ways to Save`, url: `/personal/savings/`},
            {icon: creditCardsIcon, shortText: `Credit Cards`, longText: `Find a Credit Card`, url: `/personal/credit-cards/`},
            {icon: loanIcon, shortText: `Loans`, longText: `Apply for a Loan`, url: `/personal/lending`},
            {icon: mortgageIcon, shortText: `Mortgage`, longText: `Buy or Refinance a Home`, url: `/personal/mortgage/`},
            {icon: digitalBankingIcon, shortText: `Digital Banking`, longText: `Explore Digital Banking`, url: `/personal/digital-banking`},
          ]} />
        </Grid.Block>
      </Grid.FullWidthSection>

      { /* --- CUSTOMER SERVICE SECTION ----*/ }
      <CustomerServiceSection />

      { /* --- Digital Banking SECTION ----*/ }
      <Grid.FullWidthSection styles={{
        padding: `4rem 0`,
        background: `#fff`,
        alignItems: `center`,
        boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`,
        overflowX: `hidden`,
      }}>
        <Grid.Block start={[2, 2, 9, 9,9,9]} span={[12,12,7,6,6,4]} css={{
          marginBottom: `2rem`,
          gridRowStart: `1`,
          '@media (min-width: 1495px)': {
            marginBottom: `0`
          }
        }}> 
          <StaticImage 
            css={{
              display: `block !important`,  
              '@media (min-width: 736px)': { display: 'none !important' },
              '@media (min-width: 1024px)': { display: 'block !important' } 
            }} 
            src="../../images/products/digital-banking/tcb-debit-card-controls_full.png" 
            alt="TCB Digital Banking Card Controls and Debit Card" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' },
              
            }} 
            src="../../images/products/digital-banking/tcb-debit-card-controls_cropped.png" 
            alt="TCB Digital Banking Card Controls and Debit Card" 
          />

        </Grid.Block>
        <Grid.Block start={[2,2,2,2, 2, 3]} span={[12,12,7,8, 7, 6]} css={{
          '@media (min-width: 755px)': {
            gridRowStart:  `-1`
          }
        }}>
          <Canon as="h1">The TCB MasterCard Debit Card Is Even Better with the TCB Digital Banking App</Canon>
            <Body css={{textAlign: `justify`}}>
              Take control of your card.  The Claxton Bank MasterCard Debit Card is accepted virtually anywhere 
              you see the MasterCard logo, and our debit card is an easy way to manage your money, wherever you 
              are. And now the iBankTCB digital banking app takes it one step further, giving you the ability to 
              control and protect your bank account anytime, anywhere. The TCB Card Controls feature allows you 
              to turn your card on and off. You can activate your TCB MasterCard and change your PIN from the app 
              anywhere you have cell phone service. In case of emergency, use the app to request a temporary limit 
              increase for ATM withdrawals. It’s safe, convenient, and straightforward. The Claxton Bank MasterCard 
              debit card is an easy way to manage your money, wherever you are.
            </Body>
            <div css={{marginTop: `2rem`}}>
                          <PhExternalLink to="https://apps.apple.com/us/app/the-claxton-bank-mobile/id994317983?ign-mpt=uo%3D4">
                <StaticImage src="../images/products/digital-banking/app-store-badge.png" alt="Download on the App Store" height="50" width="168" />
              </PhExternalLink>
              <PhExternalLink to="https://play.google.com/store/apps/details?id=com.csiweb.digitalbanking.bk0704"><StaticImage src="../images/products/digital-banking/google-play-badge.png" alt="Get it on Google Play" height="50" width="168"/></PhExternalLink><br />
            <Link css={{display: `inline-block`, marginTop: `2rem`, textDecoration: `none` }} to="/personal/digital-banking">Learn More About Digital Banking &nbsp; <Icon icon={linkIcon} overrides={{verticalAlign: `0em !important`}}/></Link>
            </div>
          </Grid.Block>
      </Grid.FullWidthSection>

      { /* --- Digital Banking SECTION ----*/ }
      {/* <Grid.FullWidthSection styles={{
        padding: `6rem 0`,
        //background: `#fff`,
        textAlign: `center`,
      }}>
        <Grid.Block start="2" span="12">
          <Canon as="h1">Take Control of Your Finances</Canon>
        </Grid.Block>
        <Grid.Block start="3" span="10">
          <div css={{display: `flex`, justifyContent: `space-between`, flexWrap: `wrap`}}>
          <ResourcesTile width="46vw" src={`https://static-app-misc.teachbanzai.com/img/fws-hero-illustration2.jpg`}/>
          <ResourcesTile width="28vw"/>

          <ResourcesTile width="28vw"/>
          <ResourcesTile width="46vw"/>
          
          </div>
        </Grid.Block> */}
        { /** 
        <Grid.Block start="2" span="12">
          <div css={{
            display: `flex`,
            justifyContent: `space-between`,
            margin: `auto`,
            '.container__item': {
              alignContent: `center`,
              border: `1px solid #333`,
              display: `flex`,
              flexBasis: `1`,
              justifyContent: `center`,
              marginBottom: `2vw`,
              width: `21vw`,
              height: `21vw`,
            }
          }}>
            <div className="container__item">
              <ResourcesTile />
            </div>
            <div className="container__item">Test Content 1</div>
            <div className="container__item">Test Content 1</div>
            <div className="container__item">Test Content 1</div>
          </div>
        </Grid.Block>
         */}
      {/* </Layout></Grid.FullWidthSection> */}

         <ReviewSection />
    </Layout>
  )
}

export default PersonalIndexPage


